// Versión de Klyndu que se muestra en el programa. Se sube en cada
// actualización según el plan de docs/VERSIONES.md (y la etiqueta de git vX.Y).
export const VERSION = '0.4';
